import React, { Fragment, Suspense, useEffect, useState } from "react";
import { Routes, Route, Navigate, Outlet, useNavigate } from "react-router-dom";
import routesNames from "./RouteNames";
import ProtectedRoute from "./ProtectedRoutes";
import { CircularLoader } from "../components/common/loaders/CircularLoader";
import { getLocalStorageItem } from "../utils/LocalStorage";
import { pageRoutes } from "./PageRoutes";
import { useDispatch, useSelector } from "react-redux";
import { loginRedux } from "../redux/login-redux/LoginRedux";
import EditPost from "../pages/create-post/edit-post/EditPost";
import ComingSoon from "../pages/coming-soon/ComingSoon";
import AddArtists from "../pages/dashboard/project-details/add-artists/AddArtists";
import ViewAllProjects from "../pages/self-profile/view-all-projects/ViewAllProjects";
import ProjectEndingFlow from "../pages/create-project/project-ending-flow/ProjectEndingFlow";
import { messaging } from "../firebase.config";
import { getToken, onMessage, isSupported } from "firebase/messaging";
import { UAParser } from "ua-parser-js";
import MobileLandingPage from "../pages/landing/MobileLanding";
import useWindowDimensions from "../custom/useWindowDimensions";
import MobileBlockUsersList from "../pages/help-and-support/BlockUsers/MobileBlockUsersList";
import InfoGraphics from "../pages/home/info-graphics/InfoGraphics";
import { getCookies } from "../utils/Cookies";
import RegistrationV1 from "../pages/user-management/registration/RegistrationV1/RegistrationV1";
import posthog from "posthog-js";
import EventDetailPage from "../pages/events/event-details/EventDetailsPage";
import { CollaborationAgreement, CollaborationPolicy, CommunityGuidelines, PrivacyPolicy, TermsAndConditions } from "../pages/help-and-support/help/policies/terms-and-condition";
import RefundPolicy from "../pages/help-and-support/help/policies/RefundPolicy";
import CookiePolicy from "../pages/help-and-support/help/policies/CookiePolicy";
import AccountDeletionPolicy from "../pages/help-and-support/help/policies/AccountDeletePolicy";
import Policies from "../pages/help-and-support/help/policies";


const {
  // login and registration
  Registration,
  CreateUser,
  Login,
  AlreadyUserExist,

  // home
  HomeContainer,
  Home,
  ViewPost,
  Upload,

  // Blogs
  Blogs,

  // profile & selfProfile
  SelfProfile,
  EditProfile,
  Favourites,

  // profile & selfProfile
  Notifications,

  // Explore
  Explore,
  // Create-project
  CreateProject,
  ArtistDetails,
  PreviewProject,

  // Create-post
  CreatePost,
  PreviewPost,
  PostReorder,
  AddPostDetails,

  // Help and Support
  HelpAndSupport,
  Help,
  HelpCentre,
  ReportProblem,
  Legal,
  Faqs,
  SupportRequests,
  ProfileSecurityMobileView,
  LoginActivity,
  LoginCredentials,
  NotificationSettings,

  // Dashboard
  MyCalender,
  Dashboard,
  MyProjects,
  MyCollaborators,
  ProjectDetails,
  AskToCollaborate,
  ProjectOwnerView,
  InviteMoreCollaborator,
  PreviewTask,
  CreateTask,
  CollaboratorView,
  RequestNegotiation,
  ApplyProject,
  SketchBoard,
  MediaGallery,
  Chats,
} = pageRoutes;

const AppRoutes = () => {
  const navigate = useNavigate();
  const loginState: any = useSelector((state: any) => state.Login);

  const { screenSize } = useWindowDimensions();

  const actionDispatch = (dispatch: any) => ({
    setLoginState: (data: any) =>
      dispatch(loginRedux.actions.setLoginState(data)),
    updateFCMTokenRequest: (data: any) =>
      dispatch(loginRedux.actions.updateFCMTokenRequest(data)),
  });
  const { setLoginState, updateFCMTokenRequest } = actionDispatch(useDispatch());

  const [deviceInfo, setDeviceInfo] = useState({ device: '', os: '', browser: '' });

  const loggedInUser = getLocalStorageItem("token");
  const userDetails: any = getCookies("userDetails");
  const loginUserDetails = userDetails && JSON.parse(userDetails);

  useEffect(() => {
    const parser = new UAParser();
    const result = parser.getResult();
    setDeviceInfo({
      device: result.device.model || 'Unknown Device',
      os: result.os.name || 'Unknown OS',
      browser: result.browser.name || 'Unknown Browser'
    });
  }, []);


  useEffect(() => {
    // Detect if the platform is iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (loginState?.isLoginOtpVerified) {
      navigate(routesNames?.home);
      setLoginState({ key: "isLoginOtpVerified", value: false });

      // Skip Firebase Messaging on iOS
      if (!isIOS) {
        Notification.requestPermission()
          .then((permission) => {
            if (permission === 'granted') {
              console.log("Notification permission granted.");

              // Check if Firebase Messaging is supported in this browser
              isSupported()
                .then((supported) => {
                  if (supported) {
                    // Get FCM token
                    getToken(messaging, {
                      vapidKey: "BEd4veykOvzsmaP6kVcsWVSMnLf0OISTsDbBzLVyfYq7rqDIqw7_OlGFIYqAzov8SqiIKLhA3OIl-Wvj6m-xzMM",
                    })
                      .then((currentToken) => {
                        if (currentToken) {
                          console.log("FCM Token:", currentToken);

                          // Send the token to your server
                          updateFCMTokenRequest({
                            userId: loginUserDetails?.id,
                            fcmToken: currentToken,
                            deviceId: `${deviceInfo?.os} - ${deviceInfo?.browser}`,
                            channelType: 2,
                          });
                        } else {
                          console.log("No registration token available.");
                        }
                      })
                      .catch((err) => {
                        console.error("An error occurred while retrieving token.", err);
                      });
                  } else {
                    console.log("Firebase Messaging is not supported on this browser.");
                  }
                })
                .catch((err) => {
                  console.error("Error checking Firebase Messaging support:", err);
                });
            } else {
              console.log("Unable to get permission to notify.");
            }
          })
          .catch((err) => {
            console.error("Error requesting notification permission:", err);
          });
      } else {
        console.log("Skipping Firebase Messaging on iOS.");
      }
    }
  }, [loginState?.isLoginOtpVerified]);


  // useEffect(() => {
  //   if (loginState?.isLoginOtpVerified) {
  //     navigate(routesNames?.home);
  //     setLoginState({ key: "isLoginOtpVerified", value: false });

  //     Notification.requestPermission()
  //       .then((permission) => {
  //         if (permission === 'granted') {
  //           console.log("Notification permission granted.");

  //           // Check if Firebase Messaging is supported in this browser
  //           isSupported()
  //             .then((supported) => {
  //               if (supported) {
  //                 // Get FCM token
  //                 getToken(messaging, {
  //                   vapidKey: "BEd4veykOvzsmaP6kVcsWVSMnLf0OISTsDbBzLVyfYq7rqDIqw7_OlGFIYqAzov8SqiIKLhA3OIl-Wvj6m-xzMM",
  //                 })
  //                   .then((currentToken) => {
  //                     if (currentToken) {
  //                       console.log("FCM Token:", currentToken);

  //                       // Send the token to your server
  //                       updateFCMTokenRequest({
  //                         userId: loginUserDetails?.id,
  //                         fcmToken: currentToken,
  //                         deviceId: `${deviceInfo?.os} - ${deviceInfo?.browser}`,
  //                         channelType: 2,
  //                       });
  //                     } else {
  //                       console.log("No registration token available.");
  //                     }
  //                   })
  //                   .catch((err) => {
  //                     console.error("An error occurred while retrieving token.", err);
  //                   });
  //               } else {
  //                 console.log("Firebase Messaging is not supported on this browser.");
  //               }
  //             })
  //             .catch((err) => {
  //               console.error("Error checking Firebase Messaging support:", err);
  //             });
  //         } else {
  //           console.log("Unable to get permission to notify.");
  //         }
  //       })
  //       .catch((err) => {
  //         console.error("Error requesting notification permission:", err);
  //       });
  //   }
  // }, [loginState?.isLoginOtpVerified]);

  useEffect(() => {
    if (loginUserDetails?.id) {
      posthog?.identify(loginUserDetails.id, {
        email: `${loginUserDetails.userName}@posthog.com`,
        fullName: loginUserDetails.fullName
      })
    }
  }, [posthog, loginUserDetails])

  let routes = (
    <Fragment>
      <Route path="/" element={screenSize?.dynamicWidth > 786 ? <Login /> : <MobileLandingPage />} />
      <Route path="/landing" element={screenSize?.dynamicWidth > 786 ? <Login /> : <MobileLandingPage />} />
      <Route path={routesNames.login} element={<Login />} />
      <Route path={routesNames.registration} element={<RegistrationV1 />} />
      {/* <Route path={routesNames.createProfile} element={<MobileVerification />} /> */}
      <Route
        path={routesNames.createProfileForGoogle}
        element={<CreateUser />}
      />
      <Route path={routesNames.userExist} element={<AlreadyUserExist />} />
      <Route path={routesNames.comingSoon} element={<ComingSoon />} />
      <Route path={routesNames.viewpost} element={<ViewPost />} />
      <Route path={routesNames.termsAndConditionPolicy} element={<TermsAndConditions />} />
      <Route path={routesNames.privacyPolicy} element={<PrivacyPolicy />} />
      <Route path={routesNames.cookiePolicy} element={<CookiePolicy />} />
      <Route path={routesNames.accountDeletionPolicy} element={<AccountDeletionPolicy />} />
      <Route path={routesNames.collaborationPolicy} element={<CollaborationPolicy />} />
      <Route path={routesNames.communityGuidelines} element={<CommunityGuidelines />} />
      <Route path={routesNames.collaborationAgreement} element={<CollaborationAgreement />} />
      <Route path={routesNames.refundPolicy} element={<RefundPolicy />} />
      <Route path={routesNames.eventDetails} element={<EventDetailPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Fragment>
  );

  if (loggedInUser) {
    routes = (
      <Route element={<ProtectedRoute />}>
        {/* create post and project  */}
        <Route
          path={routesNames.upload}
          element={
            <Upload>
              {" "}
              <Outlet />{" "}
            </Upload>
          }
        >
          <Route path={routesNames.createProject} element={<CreateProject />} />
          <Route
            path={routesNames.upload}
            element={<Home isAppliedOpacity={true} />}
          />
          <Route path={routesNames.createPost} element={<CreatePost />} />
          <Route path={routesNames.artistDetails} element={<ArtistDetails />} />
          <Route path={routesNames.previewPost} element={<PreviewPost />} />
          <Route
            path={routesNames.addPostDetails}
            element={<AddPostDetails />}
          />
          <Route path={routesNames.postReorder} element={<PostReorder />} />
          <Route path={routesNames.artistDetails} element={<ArtistDetails />} />
          <Route
            path={routesNames.previewProject}
            element={<PreviewProject />}
          />
        </Route>

        <Route path={routesNames.profile} element={<SelfProfile />} />
        <Route path={routesNames.othersProfile} element={<SelfProfile />} />
        <Route path={routesNames.editProfile} element={<EditProfile />} />
        <Route path={routesNames.favourite} element={<Favourites />} />

        {/* //events */}
        <Route path={routesNames.eventDetails} element={<EventDetailPage />} />

        {/* dashboard */}
        <Route path={routesNames.dashboard} element={<Dashboard />} />
        <Route path={routesNames.myProjects} element={<MyProjects />} />
        <Route
          path={routesNames.myCollaborations}
          element={<MyCollaborators />}
        />
        <Route path={routesNames.myCalender} element={<MyCalender />} />
        <Route path={routesNames.mediaGallery} element={<MediaGallery />} />
        <Route path={routesNames.scribbleBoard} element={<SketchBoard />} />
        <Route path={routesNames.projectDetails} element={<ProjectDetails />} />
        <Route
          path={routesNames.askToCollaborate}
          element={<AskToCollaborate />}
        />
        <Route
          path={routesNames.viewAllArtists}
          element={<ProjectOwnerView />}
        />
        <Route path={routesNames.addArtists} element={<AddArtists />} />
        <Route
          path={routesNames.viewAllCollaborator}
          element={<CollaboratorView />}
        />
        <Route
          path={routesNames.inviteMoreCollaborator}
          element={<InviteMoreCollaborator />}
        />
        <Route path={routesNames.previewTask} element={<PreviewTask />} />
        <Route path={routesNames.createTask} element={<CreateTask />} />
        <Route path={routesNames.endProject} element={<ProjectEndingFlow />} />
        <Route
          path={routesNames.requestNegotiation}
          element={<RequestNegotiation />}
        />

        {/* policies */}
        <Route path={routesNames.policies} element={<Policies />} />
        <Route path={routesNames.termsAndConditionPolicy} element={<TermsAndConditions />} />
        <Route path={routesNames.privacyPolicy} element={<PrivacyPolicy />} />
        <Route path={routesNames.cookiePolicy} element={<CookiePolicy />} />
        <Route path={routesNames.accountDeletionPolicy} element={<AccountDeletionPolicy />} />
        <Route path={routesNames.collaborationPolicy} element={<CollaborationPolicy />} />
        <Route path={routesNames.communityGuidelines} element={<CommunityGuidelines />} />
        <Route path={routesNames.collaborationAgreement} element={<CollaborationAgreement />} />
        <Route path={routesNames.refundPolicy} element={<RefundPolicy />} />

        {/* Help and support */}
        <Route
          path={routesNames.profileSettings}
          element={<HelpAndSupport />}
        />
        <Route
          path={routesNames.blockedUsers}
          element={<MobileBlockUsersList />}
        />
        <Route path={routesNames.helpAndSupport} element={<Help />} />
        <Route path={routesNames.helpCentre} element={<HelpCentre />} />
        <Route path={routesNames.reportProblem} element={<ReportProblem />} />
        <Route path={routesNames.sendFeedback} element={<ReportProblem />} />
        <Route path={routesNames.legal} element={<Legal />} />
        <Route path={routesNames.faqSettings} element={<Faqs />} />
        <Route path={routesNames.editPost} element={<EditPost />} />
        <Route
          path={routesNames.supportRequests}
          element={<SupportRequests />}
        />
        <Route
          path={routesNames.viewAllProjects}
          element={<ViewAllProjects />}
        />
        <Route
          path={routesNames.profileSecurity}
          element={<ProfileSecurityMobileView />}
        />
        <Route path={routesNames.loginActivity} element={<LoginActivity />} />
        <Route
          path={routesNames.loginCredentials}
          element={<LoginCredentials />}
        />
        <Route
          path={routesNames.notofiactionsSettings}
          element={<NotificationSettings />}
        />
        <Route
          path={routesNames.exploreQuickApply}
          element={<ApplyProject />}
        />

        <Route
          path={routesNames.notifications}
          element={
            <Notifications>
              <Outlet />
            </Notifications>
          }
        >
          <Route path={routesNames.notifications} element={<Home />} />
        </Route>

        <Route
          path={routesNames.home}
          element={
            <HomeContainer>
              <Outlet />
            </HomeContainer>
          }
        >
          <Route path={routesNames.home} element={<Home />} />
          <Route path={routesNames.viewpost} element={<ViewPost />} />
          <Route path={routesNames.infoGraphics} element={<InfoGraphics />} />
          {/* <Route path={routesNames.events} element={<Events />} /> */}
          {/* <Route path={routesNames.viewEvent} element={<ViewEvent />} /> */}
        </Route>

        {/* <Route path={routesNames.viewBlogs} element={<BlogCompleteView />} /> */}

        <Route path={routesNames.explore} element={<Explore />} />
        <Route path={routesNames.blogs} element={<Blogs />} />

        <Route path="*" element={<Navigate to={routesNames.home} />} />
        {/* <Route path={routesNames.search} element={<Search />} /> */}
        <Route path={routesNames.chat} element={<Chats />} />
      </Route>
    );
  }
  return (
    <Suspense fallback={<CircularLoader />}>
      <Routes>{routes}</Routes>;
    </Suspense>
  );
};

export default AppRoutes;
